import React from 'react';
import PageTitle from '../../Components/PageTitle';
import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';



const  Career = () => {
	return (
		<>
        <PageTitle title="Career" />
        <section className="career_heading_section">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="career_heading text-center">
                            <h3>Come Join Us!</h3>
                            <h6>Great Opportunities For Freshers And Experienced</h6>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas id dolor
                                ante faucibus ultricies nec id mauris. Nam luctus erat viverra tincidunt Lorem
                                ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="career_section">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="career_detail_area">
                        <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        Branch Manager
                                    </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="accordion-body">
                                                <h2>Position: Branch Manager</h2>
                                                <p>Location: <strong>Gurugram</strong></p>
                                                <p>Eligibility: <strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas id dolor.</strong></p>

                                                <ul>
                                                    <h5>Requirements</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>

                                                <ul>
                                                    <h5>Responsibilities</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>
                                                <div className="applynow text-end">
                                                    <Link to="/" className="btn-primary_set">Apply now</Link>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        Branch Manager
                                    </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="accordion-body">
                                                <h2>Position: Branch Manager</h2>
                                                <p>Location: <strong>Gurugram</strong></p>
                                                <p>Eligibility: <strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas id dolor.</strong></p>

                                                <ul>
                                                    <h5>Requirements</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>

                                                <ul>
                                                    <h5>Responsibilities</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>
                                                <div className="applynow text-end">
                                                    <Link to="/" className="btn-primary_set">Apply now</Link>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        Branch Manager
                                    </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="accordion-body">
                                                <h2>Position: Branch Manager</h2>
                                                <p>Location: <strong>Gurugram</strong></p>
                                                <p>Eligibility: <strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas id dolor.</strong></p>

                                                <ul>
                                                    <h5>Requirements</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>

                                                <ul>
                                                    <h5>Responsibilities</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>
                                                <div className="applynow text-end">
                                                    <Link to="/" className="btn-primary_set">Apply now</Link>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        Branch Manager
                                    </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="accordion-body">
                                                <h2>Position: Branch Manager</h2>
                                                <p>Location: <strong>Gurugram</strong></p>
                                                <p>Eligibility: <strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas id dolor.</strong></p>

                                                <ul>
                                                    <h5>Requirements</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>

                                                <ul>
                                                    <h5>Responsibilities</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>
                                                <div className="applynow text-end">
                                                    <Link to="/" className="btn-primary_set">Apply now</Link>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        Branch Manager
                                    </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="accordion-body">
                                                <h2>Position: Branch Manager</h2>
                                                <p>Location: <strong>Gurugram</strong></p>
                                                <p>Eligibility: <strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas id dolor.</strong></p>

                                                <ul>
                                                    <h5>Requirements</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>

                                                <ul>
                                                    <h5>Responsibilities</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>
                                                <div className="applynow text-end">
                                                    <Link to="/" className="btn-primary_set">Apply now</Link>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        Branch Manager
                                    </Accordion.Header>
                                        <Accordion.Body>
                                            <div className="accordion-body">
                                                <h2>Position: Branch Manager</h2>
                                                <p>Location: <strong>Gurugram</strong></p>
                                                <p>Eligibility: <strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas id dolor.</strong></p>

                                                <ul>
                                                    <h5>Requirements</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>

                                                <ul>
                                                    <h5>Responsibilities</h5>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum.</li>
                                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit.</li>
                                                </ul>
                                                <div className="applynow text-end">
                                                    <Link to="/" className="btn-primary_set">Apply now</Link>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default Career;